module.exports = __webpack_public_path__ + "static/media/search.5b480b63.svg";